/* eslint-disable react/jsx-key, react/no-array-index-key */
import React from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { useDispatch } from 'react-redux';

import { isAndroidModal } from '../../redux/slices/courseConsumption';

import { getDeviceTypeAndroid } from '../../utils/helper';

import styles from './FreeCourses.module.scss';

function FreeCoursesCard({ data, skeleton }) {
  const router = useRouter();
  const dispatch = useDispatch();
  const [isAndroid, setIsAndroid] = React.useState(false);
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const { userAgent } = window.navigator;
      setIsAndroid(getDeviceTypeAndroid(userAgent));
    }
  }, []);

  const handleFreeCourseClick = (val) => {
    if (isAndroid) {
      dispatch(isAndroidModal({ show: true }));
    } else {
      const redirectLink = `/course-detail/${val}`;
      router.push(redirectLink);
    }
  };
  if (skeleton) {
    return [...Array(20)]?.map((index) => (
      <div className={`${styles.skeleton} ${styles.FreeCourseOuterWrapper}`} key={index + 1}>
        <div className={`${styles.freeCourseSkeleton} ${styles.freeCourseThumbnail}`} />
        <span className={`${styles.freeCourseSkeleton} ${styles.freeCourseTitle}`} />
      </div>
    ));
  }
  return data?.map((item) => (
    <div
      className={styles.FreeCourseOuterWrapper}
      onClick={() => handleFreeCourseClick(item?.course_slug)}
      key={item?.course_id}
    >
      <Image
        src={item?.thumbnail}
        className={styles.freeCourseThumbnail}
        alt={item?.course_title}
        width={240}
        height={152}
        placeholder={item?.thumbnail ? 'blur' : 'empty'}
        blurDataURL={item?.thumbnail}
      />
      <span className={styles.freeCourseTitle}>{item?.course_title}</span>
    </div>
  ));
}

export default FreeCoursesCard;
